(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
	  constructor() {
	    super();

	    const excludedHandles = new Set([
	      'shipping-protection',
	      'yokkao-gloves-deodorizer',
	      'yokkao-gloves-deodorizer-free-gift'
	    ]);

	    const removeCard = (element) => {
	      const card = element.closest('.card--product, .grid__item, .product-card, li, article') || element;
	      card.remove();
	    };

	    const pruneExcluded = (root) => {
	      root.querySelectorAll('[data-product-handle], [data-handle]').forEach(element => {
	        const handle = (element.getAttribute('data-product-handle') || element.getAttribute('data-handle') || '').toLowerCase();
	        if (excludedHandles.has(handle)) removeCard(element);
	      });

	      root.querySelectorAll('a[href*="/products/"]').forEach(anchor => {
	        const match = anchor.getAttribute('href').toLowerCase().match(/\/products\/([^/?#]+)/);
	        if (match && excludedHandles.has(match[1])) removeCard(anchor);
	      });

	      root.querySelectorAll('[data-product-tags], [data-product-type]').forEach(element => {
	        const tags = (element.getAttribute('data-product-tags') || '').toLowerCase();
	        const productType = (element.getAttribute('data-product-type') || '').toLowerCase();
	        if (
	          tags.includes('hidden-addon') ||
	          tags.includes('internal-gift') ||
	          tags.includes('gwp-only') ||
	          productType === 'internal gift' ||
	          productType.includes('shipping protection')
	        ) {
	          removeCard(element);
	        }
	      });
	    };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

	          pruneExcluded(html);

            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
	            const tmp = document.createElement('div');
              tmp.innerHTML = recommendations.innerHTML.trim();
              pruneExcluded(tmp);
              if (tmp.querySelector('.grid__item, .product-card, li, article')) {
                this.innerHTML = tmp.innerHTML;
                this.classList.add('product-recommendations--loaded');
              }
            }
          })
          .catch(e => { console.error(e); });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
